import { Button, Col, Form, Input, Modal, Row, Select } from 'antd';
import { useEffect, useState } from 'react';
import { useFormContext } from '../../Context/DeclarationContext';
import { getAccidentCauses, getAccidentTypes, getSignages, verifyByPlate } from '../../Services/declarations';
import './desciption_accident_form.scss';

const { Option } = Select;

interface Adjunto {
  structureAdjunto: any;
  setStructureAdjunto: any;
}
export const DescriptionAccidentFormComponent = ({ structureAdjunto, setStructureAdjunto }: Adjunto) => {
  const { state, dispatch } = useFormContext();
  const [claim, setClaim] = useState<any[]>([]);
  const [causeClaim, setCauseClaim] = useState<any[]>([]);
  const [signages, setSignages] = useState<any[]>([]);
  const [showDetail, setShowDetail] = useState<boolean>(false);
  const [element_form] = Form.useForm();
  const [validarMessageSiniestro, setValidarMessageSiniestro] = useState<boolean>(true);
  const [validarMessageVehiculo, setValidarMessageVehiculo] = useState<boolean>(true);
  const [cause, setCause] = useState<string>();
  const [type, setType] = useState<string>();
  const [open, setOpen] = useState<boolean>();
  const [causeName, setCauseName] = useState<string>(state.state_form.nameOptionDescriptionAccidemt ?? '');
  const [typeName, setTypeName] = useState<string>(state.state_form.nameClaimCauseId ?? '');

  const [validarMessageObservacines, setValidarMessageObservacines] = useState<boolean>(true);

  const handleCloseModal = async () => {
    setCauseClaim([]);
    element_form.setFieldsValue({
      claimCauseId: null,
      fixOptionDescriptionAccidemt: null,
    });

    dispatch({
      type: 'UPDATE_DESCRIPTIONS_ACCIDENT',
      payload: {
        ...state,
        fixOptionDescriptionAccidemt: null,
        claimCauseId: null,
      },
    });

    dispatch({
      type: 'UPDATE_STATE_FORM',
      payload: {
        ...state.state_form,
        nameClaimCauseId: null,
        nameOptionDescriptionAccidemt: null,
      },
    });
    setOpen(false);
  };

  useEffect(() => {
    const checkIDNR = async () => {
      try {
        if (state?.vehiclePatente?.deviceId) {
          if (
            (state?.state_form?.nameOptionDescriptionAccidemt === 'ROBO' &&
              state?.state_form.nameClaimCauseId === 'Robo habido (vehículo encontrado)') ||
            (state?.state_form?.nameOptionDescriptionAccidemt === 'ROBO' &&
              state?.state_form.nameClaimCauseId === 'Robo no habido (vehículo no encontrado)')
          ) {
            await verifyByPlate(state?.vehiclePatente?.deviceId);
          } else {
            return;
          }
        }
      } catch (error) {
        if (error) {
          setOpen(true);
        }
      }
    };
    checkIDNR();
  }, [cause, type, state]);

  useEffect(() => {
    dispatch({
      type: 'UPDATE_CURRENT_FORM_ELEMENT',
      payload: element_form,
    });
  }, [state.step]);

  const onChangueClaim = (value: string) => {
    setCause(value);
    const name = claim.find((item: any) => item.id === value)?.name;

    if (`${name}`.toLocaleUpperCase() === 'ROBO') {
      const noAplica = signages.find((item) => `${item.name}`.toLocaleLowerCase() === 'ninguna');
      if (noAplica) {
        element_form.setFieldsValue({ signages: noAplica.id });
      }
    }

    setCauseName(name);
    dispatch({
      type: 'UPDATE_STATE_FORM',
      payload: {
        ...state.state_form,
        nameOptionDescriptionAccidemt: name,
      },
    });

    getAccidentCauses(value)
      .then((res) => {
        setCauseClaim(res.data);
      })
      .finally(() => {
        element_form.setFieldsValue({ claimCauseId: undefined });
      });

    setShowDetail(true);
  };

  const changueClaim = (value: string, preserveCausaSiniestro: string = '') => {
    setCause(value);
    const name = claim.find((item: any) => item.id === value)?.name;
    setCauseName(name);
    dispatch({
      type: 'UPDATE_STATE_FORM',
      payload: {
        ...state.state_form,
        nameOptionDescriptionAccidemt: name,
      },
    });

    getAccidentCauses(value)
      .then((res) => {
        setCauseClaim(res.data);
      })
      .finally(() => {
        if (preserveCausaSiniestro?.length > 0) {
          element_form.setFieldsValue({ claimCauseId: preserveCausaSiniestro });
        } else {
          element_form.setFieldsValue({ claimCauseId: undefined });
        }
      });

    setShowDetail(true);
  };

  const onChangueCauseClaim = (value: string) => {
    const name = causeClaim.find((item: any) => item.id === value)?.name;
    dispatch({
      type: 'UPDATE_STATE_FORM',
      payload: {
        ...state.state_form,
        nameClaimCauseId: name,
      },
    });
    setTypeName(name);
    setType(value);
  };

  useEffect(() => {
    getAccidentTypes()
      .then((res) => {
        setClaim(res.data.types);
      })
      .finally(() => {
        if (state.fixOptionDescriptionAccidemt) {
          element_form.setFieldsValue({
            fixOptionDescriptionAccidemt: state.fixOptionDescriptionAccidemt,
          });
          changueClaim(state.fixOptionDescriptionAccidemt, state.claimCauseId);
        }
      });

    getSignages()
      .then((res) => {
        setSignages(res.data.signages);
      })
      .finally(() => {
        if (state.signages) {
          element_form.setFieldsValue({
            signages: state.signages,
          });
        }
      });
  }, []);

  useEffect(() => {
    element_form.setFieldsValue({
      fixOptionDescriptionAccidemt: state.fixOptionDescriptionAccidemt,
      claimCauseId: state.claimCauseId,
      signages: state.signages,
      description: state.description,
      vehicleDamageComponents: state.vehicleDamageComponents,
      additionalNotes: state.additionalNotes,
    });

    if (claim?.length) {
      const name = claim?.find((claim) => claim.id === state.fixOptionDescriptionAccidemt)?.name;
      dispatch({
        type: 'UPDATE_STATE_FORM',
        payload: {
          ...state.state_form,
          nameOptionDescriptionAccidemt: name,
        },
      });
    }
  }, [claim]);

  const onChangeValues = (changedValues: any, allValues: any) => {
    const { fixOptionDescriptionAccidemt, claimCauseId, signages, description, vehicleDamageComponents, additionalNotes } = allValues;

    dispatch({
      type: 'UPDATE_DESCRIPTIONS_ACCIDENT',
      payload: {
        fixOptionDescriptionAccidemt,
        claimCauseId,
        description,
        vehicleDamageComponents,
        additionalNotes,
        signages,
      },
    });
  };

  const onFinish = (values: any) => {
    console.log('values', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('errorInfo', errorInfo);
  };
  return (
    <div className="description_accident_form">
      <div className="title">4. Descripción del accidente</div>
      <div className="sub_title">Los campos marcados con el asterisco (*) son obligatorios.</div>

      <Form onFinish={onFinish} onFinishFailed={onFinishFailed} onValuesChange={onChangeValues} colon={false} form={element_form} autoComplete="off">
        <Row gutter={[24, 24]} style={{ marginTop: '14px' }}>
          <Col sm={8} xs={24}>
            <Form.Item
              label="Tipo de siniestro"
              name="fixOptionDescriptionAccidemt"
              rules={[
                {
                  required: true,
                  message: 'Debe ingresar el tipo de siniestro',
                },
              ]}
            >
              <Select placeholder="Seleccionar" onChange={onChangueClaim} id="fixOptionDescriptionAccidemt">
                {claim?.map((item: any) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {true && (
            <>
              <Col sm={8} xs={24}>
                <Form.Item
                  label="Causa del siniestro"
                  name="claimCauseId"
                  rules={[
                    {
                      required: true,
                      message: 'Debe ingresar la causa del siniestro',
                    },
                  ]}
                >
                  <Select
                    placeholder="Seleccionar"
                    onChange={onChangueCauseClaim}
                    showSearch
                    filterOption={(input: string, option?: { label: string; value: string }) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={causeClaim?.map((item) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                  ></Select>
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item
                  label="Indique la señalética presente"
                  name="signages"
                  rules={[
                    {
                      required: true,
                      message: 'Debe ingresar este campo',
                    },
                  ]}
                >
                  <Select
                    placeholder="Seleccionar"
                    showSearch
                    filterOption={(input: string, option?: { label: string; value: string }) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={signages?.map((item) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                  ></Select>
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item
                  label="Relate finalmente como ocurrió el siniestro"
                  name="description"
                  extra={validarMessageSiniestro ? 'La cantidad máxima es de 1.000 caracteres' : null}
                  rules={[
                    // validar que solo sean 1000 caracteres y eliminar el campo extra
                    {
                      required: true,
                      message: 'Debe ingresar este campo',
                    },
                    {
                      pattern: /^[a-zA-Z0-9#&ñÑ.,()ÑñÁáÉéÍíÓóÚúÜü" \n\r]+$/,
                      message: 'Solo se permiten letras (a-z, A-Z), números (0-9), espacios y los caracteres como: #, &, ", ()',
                    },
                    {
                      validator: async (_, value) => {
                        if (value.length > 1000) {
                          setValidarMessageSiniestro(false);
                          return Promise.reject('La cantidad máxima es de 1.000 caracteres');
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input.TextArea rows={4} maxLength={1000} />
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item
                  label="Partes o piezas afectadas del vehículo"
                  name="vehicleDamageComponents"
                  extra={validarMessageVehiculo ? 'La cantidad máxima es de 500 caracteres' : null}
                  rules={[
                    {
                      required: true,
                      message: 'Debe ingresar este campo',
                    },
                    {
                      validator: async (_, value) => {
                        if (value.length > 500) {
                          setValidarMessageVehiculo(false);
                          return Promise.reject('La cantidad máxima es de 500 caracteres');
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input.TextArea rows={4} maxLength={500} />
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item
                  label="Otras observaciones"
                  name="additionalNotes"
                  extra={validarMessageObservacines ? 'La cantidad máxima es de 500 caracteres' : null}
                  rules={[
                    {
                      validator: async (_, value) => {
                        if (value.length > 500) {
                          setValidarMessageObservacines(false);
                          return Promise.reject('La cantidad máxima es de 500 caracteres');
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input.TextArea rows={4} maxLength={500} />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>
      </Form>

      <Modal
        open={open}
        onCancel={handleCloseModal}
        centered
        footer={
          <div className="btn_footer_modal">
            <Button type="primary" className="btnGoTheft" onClick={() => {}}>
              <a
                target="_blank"
                href={`${process.env.REACT_APP_THEFT_NOTIFICATION_URL || '/'}?patent=${state?.vehiclePatente?.deviceId}`}
                rel="noreferrer"
              >
                Ir a notificar robo
              </a>
            </Button>
          </div>
        }
      >
        <h3>La patente ingresada no esta asociada a una “Notificar robo”</h3>
        <p>
          Para continuar con la declaración, será redireccionado a la sección de “Notificar un robo”, una vez notificado, podrá continuar
          posteriormente a formalizar la declaración del siniestro por robo (vehículo no recuperado).{' '}
        </p>
      </Modal>
    </div>
  );
};
